module.exports = __webpack_public_path__ + "img/7.188a419c.jpg";